import {
    Component,
    Input,
    Output,
    ElementRef,
    OnInit,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';
import {WindowService} from "../services/window.service";
import {Product} from "../model/product";
import {ProductGroup} from "../model/product.group";
import {SubProduct} from "../model/subproduct";

import {EventsService} from "../services/events.service";
import {Logger} from "../utils/logger";


export interface CanvasProducts extends Array<ProductGroup>{}

export interface CanvasSubProducts extends Array<ProductGroup>{}

@Component({
    selector: 'canvas_panel',
    templateUrl: "./canvas.component.html"
})
export class CanvasComponent implements OnInit, OnChanges {

    @Input("products")
    public selectedProducts: CanvasProducts = null;

    @Input("subProducts")
    public selectedSubProducts: CanvasSubProducts = null;

    @Input('bg')
    public bg: string;

    @Input("top")
    public top: string;

    @Input()
    public productGroup: ProductGroup;

    @Input()
    public alternative: {index: number, groupName: string};

    @Input()
    public savedAlternatives: Array<any>;

    public canvasWidth = '0px';
    public canvasHeight = '100%';
    public marginLeft = '50%';
    public contentLoaded = false;

    public loadedImages = {
        bg: false,
        top: false,
        bathroom_floor_common: false,
        bathroom_floor_shower: false,
        bathroom_wall_left: false,
        bathroom_wall_right: false,
        bathroom_wall_shower: false,
        bathroom_furniture: false,
        isContentLoaded: () => {
            return this.contentLoaded;
        }
    };

    public imagesLoaded = 0;
    public imagesAmount = Object.keys(this.loadedImages).length - 2;

    constructor(public el: ElementRef, public winService: WindowService, public eventBus: EventsService, public logger: Logger) {

    }


    ngOnChanges(changes: any): void {
        if(changes.selectedProducts && changes.selectedProducts.currentValue && changes.selectedProducts.currentValue !== changes.selectedProducts.previousValue && !this.contentLoaded){
            this.imagesAmount = 1;
            this.selectedProducts.forEach((product) =>{
                this.imagesAmount++;
            });
        }
    }

    scaleCanvas() {
        let height = this.winService.getScreenHeight() / this.winService.getScreenZoom();
        this.canvasHeight = height + 'px';
        // let width = (height * this.winService.getAspectRatio());
        let width = this.winService.convertSize(this.winService.getMainContainerWidth());
        this.canvasWidth = width + 'px';
        this.marginLeft = (width / 2) * -1 + 'px';

        this.el.nativeElement.style.minHeight = this.canvasHeight;
    }

    ngOnInit(): any {
        this.scaleCanvas();
        this.winService.addResizeEventListener(() => {
            this.scaleCanvas();
        });
    }

    basePath() {
        return "/";
    }

    onProductImageLoaded(event: {product: Product, groupName: string}) {
        this.imagesLoaded++;
        if (!this.contentLoaded && (this.imagesLoaded >= this.imagesAmount)) {
            this.contentLoaded = true;
        }

        this.eventBus.broadcast("products.renderImageLoaded." + event.product.id.getValue() + "-" + event.product.articleNumber.getValue(), event);
        this.eventBus.broadcast("products.renderImageLoaded", event);
    }

    onSubProductImageLoaded(event: {subProduct: SubProduct, groupName: string}) {
        this.eventBus.broadcast("subProducts.renderImageLoaded." + event.subProduct.id.getValue() + "-" + event.subProduct.articleNumber.getValue(), event);
    }

    onImageLoaded() {
        this.imagesLoaded++;
        if (!this.contentLoaded && (this.imagesLoaded >= this.imagesAmount)) {
            this.contentLoaded = true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/canvas/canvas.component.ts